import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<HeadLayout />\r\n{{outlet}}\r\n<BasicDropdownWormhole />",{ moduleName: "filter-wizard/templates/application.hbs" })